export const CobrowseServiceCommand = {
  AcceptSession: 'CobrowseService.acceptSession',
  DeclineSession: 'CobrowseService.declineSession',
};
